import React, { Component } from "react";
import Group from "./Group.js";
import Empty from "./Empty.js";
import Toggle from "@atlaskit/toggle";

class Groups extends Component {
  state = { showAll: false };
  render() {
    let groupNames = Object.keys(this.props.data);
    if (!this.state.showAll) {
      groupNames = groupNames.filter(
        (name) => this.props.data[name].is_active || this.state.showAll
      );
    }
    return (
      <div>
        <div className="flex items-center float-right mb-4">
          <label className="mr-1 text-sm text-gray-600" htmlFor="showAllCheck">
            Show inactive groups
          </label>
          <Toggle
            size="large"
            id="showAllCheck"
            value={this.state.showAll}
            onChange={() => this.setState({ showAll: !this.state.showAll })}
          />
        </div>
        <div className="clear-both" />

        {groupNames.length < 1 ? (
          <Empty text="No active groups" icon="x" />
        ) : null}

        {groupNames.map((name) => (
          <Group key={name} name={name} data={this.props.data[name]} />
        ))}
      </div>
    );
  }
}

export default Groups;
